module.exports = __webpack_public_path__ + "src/img/loading.f68c555b.svg";